import {View} from '@fantasmagames/slot/src/common/view/View';
import {Timer} from '@fantasmagames/core/src/update/Timer';
import {RepeatingTimer} from '@fantasmagames/core/src/update/RepeatingTimer';

export class StatisticsWindowView extends View {
	protected _sessionInitTimestamp: Date;
	protected _timeFromSessionInitText: PIXI.Text;

	protected _spinsMade: number = 0;
	protected _spinsMadeText: PIXI.Text;

	protected _moneyLost: number = 0;
	protected _totalMoneyLostText: PIXI.Text;

	protected _moneyWon: number = 0;
	protected _totalMoneyWonText: PIXI.Text;

	// moneyWon / moneyLost
	protected _sessionRTPText: PIXI.Text;

	protected _allTextFields: PIXI.Text[] = [];

	protected _textsStyle: PIXI.TextStyle;

	protected _oneSecondTimer: Timer;

	public toggleView(): void {
		if (this.container.visible) {
			this.hide();
		} else {
			this.show();
		}
	}

	public init(): void {
		super.init();

		this.initializeBackground();
		this.initializeData();
		this.initializeTexts();
		this.placeTexts();
		this.updateTexts();
		this.initializeTimer();

		this.hide();
	}

	protected initializeTimer(): void {
		this._oneSecondTimer = new RepeatingTimer(
			() => {
				this.updateTexts();
			},
			1000,
			true,
		);
		this.updateManager.add(this._oneSecondTimer);
	}

	protected initializeBackground(): void {
		const backgroundGraphics: PIXI.Graphics = new PIXI.Graphics();

		backgroundGraphics.lineStyle(5, 0x000000, 1);
		backgroundGraphics.beginFill(0x000000, 0.25);
		if (this.device.isMobile) {
			backgroundGraphics.drawRoundedRect(
				this.resolutionManager.halfResolution.width * 1.5,
				this.resolutionManager.halfResolution.height,
				this.resolutionManager.halfResolution.width * 0.5,
				this.resolutionManager.halfResolution.height,
				15,
			);
		} else {
			backgroundGraphics.drawRoundedRect(
				this.resolutionManager.halfResolution.width * 1.5,
				this.resolutionManager.halfResolution.height,
				this.resolutionManager.halfResolution.width * 0.5,
				this.resolutionManager.halfResolution.height,
				15,
			);
		}
		backgroundGraphics.endFill();

		this.container.addChild(backgroundGraphics);
	}

	protected initializeData(): void {
		this._sessionInitTimestamp = new Date();
	}

	protected initializeTexts(): void {
		this._textsStyle = this.textStyles.freeRoundsSmallTextStyle;
		this._timeFromSessionInitText = new PIXI.Text('', this._textsStyle);
		this._allTextFields.push(this._timeFromSessionInitText);

		this._spinsMadeText = new PIXI.Text('', this._textsStyle);
		this._allTextFields.push(this._spinsMadeText);

		this._totalMoneyLostText = new PIXI.Text('', this._textsStyle);
		this._allTextFields.push(this._totalMoneyLostText);

		this._totalMoneyWonText = new PIXI.Text('', this._textsStyle);
		this._allTextFields.push(this._totalMoneyWonText);

		this._sessionRTPText = new PIXI.Text('', this._textsStyle);
		this._allTextFields.push(this._sessionRTPText);
	}

	protected placeTexts(): void {
		for (let i = 0; i < this._allTextFields.length; i++) {
			const tf: PIXI.Text = this._allTextFields[i];
			this.container.addChild(tf);
			tf.x = this.resolutionManager.halfResolution.width * 1.5 + 50;
			tf.y = this.resolutionManager.halfResolution.height + 50 + i * 40;
		}
	}

	public updateTexts(): void {
		const timeSpent: number = new Date().getTime() - this._sessionInitTimestamp.getTime();
		this._timeFromSessionInitText.text = `session time: ${new Date(timeSpent).toISOString().slice(11, 19)}`;

		this._spinsMadeText.text = `spins: ${this._spinsMade.toString(10)}`;
		this._totalMoneyLostText.text = `money lost: ${this._moneyLost.toString(10)}`;
		this._totalMoneyWonText.text = `money won: ${this._moneyWon.toString(10)}`;
		this._sessionRTPText.text = `session RTP: ${(this._moneyWon / this._moneyLost).toString(10)}`;
	}

	public spinMade(): void {
		this._spinsMade++;
		this.updateTexts();
	}

	public moneySpent(money: number): void {
		this._moneyLost += money;
		this.updateTexts();
	}

	public moneyWon(money: number): void {
		this._moneyWon += money;
		this.updateTexts();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/statistics/StatisticsWindowView.ts